import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import resource from '../../../pages/Features/ProjectHighlight/ProjectHighlight.module.css';
import { useLocation } from "react-router-dom";

export const useProjectDetails = () => {
    const tagRef = useRef(null);
    const [rowData, setRowData] = useState([])
    const gridRef = useRef();
    const [SelectTab, setSelectTab] = useState("")
    const location = useLocation().state;
    const [columnDefs] = useState([
        {
            field: 'resource_name',
            headerName: 'Resource Name',
            width: '200px',
            cellRenderer: function (params) {
                const image = params.data.user_image_url;
                const name = params.data.resource_name

                return (
                    <div className="d-flex">
                        <div>
                            <img src={image} className={resource["image"]} alt=" "></img>
                        </div>
                        <span>{name}</span>
                    </div>
                )
            }
        },
        { field: 'primary_skill_1', headerName: 'Primary Skill', width: '150px', },
        { field: 'secondary_skill_1', headerName: 'Secondary Skill', width: '130px' },
        { field: 'project_involved', headerName: 'Projects', width: '100px' },
        { field: 'earned_xp', headerName: 'Earned XP', width: '100px' },
        { field: 'next_available_date', headerName: 'Next Date', width: '130px' },
        {
            field: 'backlog_issues', headerName: 'Backlog', width: '150px', className: 'task-sec',
            cellRenderer: function (params) {
                const backlog = params.data.backlog_issues_percentage
                const progress = params.data.in_progress_issues_percentage
                const complate = params.data.completed_issues_percentage
                const baclog = params.data.backlog_features
                const done = params.data.done_features
                const active = params.data.active_features

                return (
                    <div style={{ width: '100%', height: '10px', marginTop: '5px' }}>
                        <div style={{ display: 'flex' }}>
                            <h2 style={{ fontSize: '10px', width: '100%', textAlign: 'start' }}>{baclog}</h2>
                            <h2 style={{ fontSize: '10px', width: '100%', textAlign: 'center' }}>{active}</h2>
                            <h2 style={{ fontSize: '10px', width: '100%', textAlign: 'end' }}>{done}</h2>
                        </div>

                        <div className="task-status">
                            <span className='task-backlog' style={{ width: `${backlog}` }}></span>
                            <span className='task-inprogress' style={{ width: `${progress}` }}></span>
                            <span className='task-complate' style={{ width: `${complate}` }}></span>
                        </div>
                    </div>
                )
            }
        },
        {
            field: 'bug_resolved_issue', headerName: 'Bug resolve', width: '150px',
            cellRenderer: function (params) {
                const backlogbugPr = params.data.backlog_bug_percentage
                const progressbugPr = params.data.in_progress_bug_percentage
                const complatebugPr = params.data.completed_bug_percentage
                const active = params.data.active_bugs
                const backlog = params.data.backlog_bugs
                const done = params.data.done_bugs
                return (
                    <div style={{ width: '100%', height: '10px', marginTop: '5px' }}>
                        <div style={{ display: 'flex' }}>
                            <h2 style={{ fontSize: '10px', width: '100%', textAlign: 'start' }}>{backlog}</h2>
                            <h2 style={{ fontSize: '10px', width: '100%', textAlign: 'center' }}>{active}</h2>
                            <h2 style={{ fontSize: '10px', width: '100%', textAlign: 'end' }}>{done}</h2>
                        </div>

                        <div className="task-status">
                            <span className='task-backlog' style={{ width: `${backlogbugPr}` }}></span>
                            <span className='task-inprogress' style={{ width: `${progressbugPr}` }}></span>
                            <span className='task-complate' style={{ width: `${complatebugPr}` }}></span>
                        </div>
                    </div>
                )
            }
        },
        {
            field: 'pl_sl', cellRenderer: params => {
                const rowData = params.data;
                const sick = rowData.sick_leave || 0;
                const privilage = rowData.privilage_leave || 0;
                return (
                    <div style={{ width: '100%', height: '10px' }}>
                        <div style={{ display: 'flex' }}>
                            <h2 style={{ fontSize: '13px' }}>{privilage + "/" + sick} </h2>
                        </div>
                    </div>
                );
            }, headerName: 'PL / SL', width: '100px'
        },
        { field: 'project_role_name', headerName: 'Role' }
    ])

    useEffect(() => {
        getResourceData(location?.key);
        // eslint-disable-next-line 
    }, [])

    // get project resource details
    // eslint-disable-next-line 
    const getResourceData = async (Key) => {
        setSelectTab(Key)
        const payload = {
            project_Id: location?.project_id,
            resource_key: Key || location?.key,
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTRESOURCELIST'), payload)
            const data = res.body.data.project_Resources;
            if (data) {
                setRowData(data)
            }

        } catch (error) {
            console.error('Error :', error);
        }
    };

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            'quickFilterText',
            document.getElementById('filter-text-box').value
        );
    }, []);

    // eslint-disable-next-line 
    const generateJson = async () => {
        const result = await ('Report')
        if (result) {
            try {
                const payload = {
                    'permissions': result
                };
                await services.getInvokeRemote('POST', Urls('GENERATERESOURCEPERMISSION'), payload)
            } catch (error) {
                console.error(error);
            }
        }
    }

    return useMemo(() => ({
        tagRef, onFilterTextBoxChanged, SelectTab, getResourceData, generateJson, columnDefs, gridRef, rowData
    }), [tagRef, onFilterTextBoxChanged, SelectTab, getResourceData, generateJson, columnDefs, gridRef, rowData])
}